export const home = {
  hero: {
    title: "Kwaliteitsvolle Leadlijsten",
    subtitle: "Voor Verkoopteams",
    description: "Stop met tijd verspillen aan slechte leads. Krijg telefoonnummers die opgenomen worden, bedrijven die bestaan, data die werkt.",
    freeOffer: "Eerste 100 Nummers GRATIS",
    contactButton: "Contacteer Ons",
    callButton: "Bel Ons",
    pricing: "Daarna €3 per nummer • Geen abonnement • Geen verborgen kosten"
  },
  whatWeDo: {
    title: "Waarom NovaVenture Beter Is",
    description: "Andere lijsten zitten vol faxnummers, verouderde bedrijven en nummers die nooit opnemen. Wij leveren alleen data die werkt.",
    realPhone: {
      title: "Echte Telefoonnummers",
      description: "Geen faxnummers. Geen verouderde contacten. Alleen nummers die door echte bedrijven worden opgenomen."
    },
    activeCompanies: {
      title: "Actieve Bedrijven",
      description: "Alle bedrijven gefilterd op BTW-nummer. Geen failliet of niet-bestaande bedrijven meer in je lijst."
    },
    readyToUse: {
      title: "Klaar Voor Gebruik",
      description: "Geleverd in Excel. Klaar om te importeren in je CRM. Start vandaag nog met bellen."
    }
  },
  whatYouGet: {
    title: "Wat Je Krijgt Per Lead",
    description: "Geen vage data. Geen 'bedrijfsgrootte' oplichterij. Alleen concrete informatie die je verkoopteam nodig heeft.",
    fields: {
      companyName: {
        title: "Bedrijfsnaam",
        description: "Officiële bedrijfsnaam"
      },
      vatNumber: {
        title: "BTW-nummer",
        description: "Verificatie dat bedrijf bestaat"
      },
      phoneNumber: {
        title: "Telefoonnummer",
        description: "Kwaliteitsnummer dat opneemt"
      },
      fullAddress: {
        title: "Volledig Adres",
        description: "Straat, nummer, stad"
      },
      postalCode: {
        title: "Postcode",
        description: "Voor geografische targeting"
      },
      website: {
        title: "Website",
        description: "Voor onderzoek voor je belt"
      },
      reviews: {
        title: "Reviews",
        description: "Indien beschikbaar"
      },
      openingHours: {
        title: "Openingsuren",
        description: "Weet wanneer te bellen"
      }
    },
    stats: {
      allBelgium: "Heel België",
      coverage: "Volledige dekking",
      allSectors: "Alle Sectoren",
      filterTarget: "Filter op je doelgroep",
      languages: "NL + FR",
      bothLanguages: "Beide talen"
    }
  },
  pricing: {
    title: "Transparante Prijzen",
    description: "Geen abonnementen. Geen verborgen kosten. Betaal alleen voor wat je gebruikt.",
    oneTimeOffer: "Eenmalig Aanbod",
    freeNumbers: "100 Nummers",
    completelyFree: "Volledig GRATIS",
    thenOnly: "Daarna slechts",
    perNumber: "per telefoonnummer",
    features: {
      noSubscription: "Geen abonnement vereist",
      noHiddenCosts: "Geen verborgen kosten",
      payAsYouGo: "Betaal alleen voor wat je gebruikt",
      excelDelivery: "Direct geleverd in Excel"
    },
    ctaButton: "Contacteer Ons Voor Je Gratis Nummers"
  },
  finalCta: {
    title: "Klaar Om Te Starten?",
    description: "Contacteer ons om je 100 gratis nummers te claimen. Geen creditcard vereist.",
    emailButton: "Stuur Een Email",
    callButton: "Bel Ons Direct",
    email: "Email:",
    availability: "Beschikbaar maandag tot vrijdag • Antwoord binnen 24 uur"
  },
  dataPrivacy: {
    title: "Transparantie Over Gegevensverwerking",
    description: "NovaVenture Group BV verwerkt uitsluitend publiek beschikbare bedrijfsgegevens. Ondernemingen kunnen bezwaar maken tegen opname in onze databank via",
    email: "David@novaventure.be",
    learnMore: "Meer informatie"
  }
};